import axios from "axios";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import "./UploadFile.styles.scss";

import uploadImage from "../../../img/kyc/upload/Approved.svg";
import { useNotification } from "../../Notifications/NotificationProvider";
import UploadConfirmationModal from "./uploadConfirmationModal";

const UploadFile = ({
  heading,
  help,
  imageFile,
  api,
  styles,
  varients = [],
}) => {
  const [modal, set_modal] = useState(false);
  const [uploading, set_uploading] = useState(false);
  const [response, set_response] = useState("");
  const [downloading, setDownloading] = useState(false);
  const dispatchNotification = useNotification();
  const [queryParams, setQueryParams] = useState({});

  const onDrop = useCallback(
    (acceptedFiles) => {
      uploadFile(acceptedFiles[0]);
    },
    [queryParams]
  );

  const { acceptedFiles, rejectedFiles, getRootProps, getInputProps } =
    useDropzone({
      maxFiles: 1,
      accept:
        "text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      init: function () {
        this.on("addedfile", function (file) {
          if (!file.type) {
            var ext = file.name.split(".").pop();
            console.log("extension: " + ext);
            if (ext === "xls") {
              Object.defineProperty(file, "type", {
                value: "application/vnd.ms-excel",
              }); // MIME type
            }
          }
        });
      },
      onDrop,
    });

  const uploadFile = (file) => {
    set_modal(false);
    set_uploading(true);
    const formData = new FormData();

    formData.append("file", file);

    axios
      .post(`${process.env.REACT_APP_API_URL}/api/uploads/v1${api}`, formData, {
        params: queryParams,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      })
      .then((res) => {
        set_uploading(false);
        set_modal(true);
        set_response(res.data);
        console.log(res.data);
      })
      .catch((err) => {
        if (err.response)
          dispatchNotification({
            type: "ERROR",
            message: err.response.message,
          });
        set_uploading(false);
        set_modal(true);
        set_response(err.response.data);
      });
  };

  const remove = (file) => {
    acceptedFiles.splice(file, 1); // remove the file from the array
  };

  const downloadSampleFile = () => {
    if (varients.length && !queryParams.validation_type) {
      alert("Please select a validation type");
      return;
    }

    setDownloading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/uploads/v1${api}`, {
        params: queryParams,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `SAMPLE_${heading}.xlsx`);
        document.body.appendChild(link);
        link.click();
        setDownloading(false);
      })

      .catch((err) => {
        console.log(err);
        setDownloading(false);
      });
  };

  const acceptedFileItems = acceptedFiles.map((file) => (
    <li key={file.path} onClick={() => remove(file)}>
      {file.path} - {Math.round(file.size / 1000)} kilobytes
    </li>
  ));

  const fileRejectionItems = rejectedFiles.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map((e) => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  return (
    <div
      className="file-container"
      style={{
        width: 500,
      }}
    >
      <div
        {...getRootProps({ className: "upload-module-container" })}
        style={{ ...styles }}
      >
        <input {...getInputProps()} />
        <div className="image-column">
          <img src={imageFile ? imageFile : uploadImage} alt="Upload File" />
        </div>

        <div className="text-column">
          <span className="heading">
            {heading ? heading : "Missing Heading"}
          </span>

          {varients.length === 0 && (
            <span className="help" style={{ color: "#434364", opacity: 0.7 }}>
              {help ? help : "Drop a file here, or select from computer..."}
            </span>
          )}

          {varients.length > 0 && (
            <select
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                const value = e.target.value;
                if (value) {
                  setQueryParams({ validation_type: value });
                } else {
                  console.log("resetting validation type:: ", value);
                  setQueryParams({});
                }
              }}
              style={{
                width: "260px",
                "padding-left": "20px",
                "padding-right": "20px",
              }}
            >
              <option value="">Select Validation Type</option>
              {varients.map((v) => (
                <option value={v.id}>{v.name}</option>
              ))}
            </select>
          )}

          <span className="download" onClick={downloadSampleFile}>
            <i className="material-icons" style={{ fontSize: 23 }}>
              download
            </i>
            <p>
              {!downloading
                ? "Download sample file"
                : "Downloading sample file"}
            </p>
          </span>

          {downloading && (
            <div
              className="progress"
              style={{
                borderRadius: "0px 0px 8px 8px",
                margin: "0px",
              }}
            >
              <div className="indeterminate"></div>
            </div>
          )}
        </div>
        {uploading && <ProgressLoader />}
        <ul>{acceptedFileItems}</ul>
        <ul>{fileRejectionItems}</ul>
      </div>
      <UploadConfirmationModal
        show={modal}
        handleHide={() => set_modal(false)}
        data={response}
      />
    </div>
  );
};

const ProgressLoader = () => (
  <div className="progress">
    <div className="indeterminate"></div>
  </div>
);

export default UploadFile;
